/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/icon/icon_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});


/* ========== ~~~~~~~~~~ GIPHY : INSTICATOR ~~~~~~~~~~ ========== */
// STATELESS FUNCTIONAL COMPONENT
// used to create markup structure and render UI
// doesn't need all the lifecycle functions attached
const Icon = ({ svg, size }) => {
  return (
    <i className={sheet.classes.FAIcon} dangerouslySetInnerHTML={{ __html: svg }} style={{
      width: size,
      height: size
    }}
    />
  );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Icon;
